import * as pageTypes from '../types/Page';
import {pushPathToHistory} from './History';
import * as routes from '../routes';
import {changeCustomerTypeToCorporateEntity} from './Customer';

export function changePageToComplaintPreview() {
    pushPathToHistory(routes.PREVIEW_COMPLAINT);
    return {
        type: pageTypes.PAGE_GO_TO_COMPLAINT_PREVIEW_PAGE
    };
}

export function changePageToCreateComplaintCustomer() {
    return (dispatch) => {
        dispatch(changeCustomerTypeToCorporateEntity());
        return dispatch({
            type: pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_CUSTOMER_PAGE
        });
    };
}

export function changePageToCreateComplaint() {
    return (dispatch) => {
        pushPathToHistory(routes.CREATE_COMPLAINT);
        return dispatch({
            type: pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE
        });
    };
}

export function changePageToCreateComplaintPosition() {
    
    return {
        type: pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_POSITION_PAGE
    };
}

export function changePageToCreateSingleComplaintPosition() {
    
    return {
        type: pageTypes.PAGE_GO_TO_CREATE_SINGLE_COMPLAINT_POSITION_PAGE
    };
}



export function changePageToCreateComplaintPositions() {
    return {
        type: pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_POSITIONS_PAGE
    };
}

export function changePageToCreateComplaintWithoutClearingCustomerData() {
    return {
        type: pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE_WITHOUT_CUSTOMER_DATA_CLEAR
    };
}

export function changePageToPostIssueComplaint() {
    return {
        type: pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_POST_ISSUE_PAGE
    };
}

export function changePageToStartPage() {
    pushPathToHistory(routes.INDEX);
    return {
        type: pageTypes.PAGE_GO_TO_START_PAGE
    };
}

export function changePageToSearchComplaint() {
    pushPathToHistory(routes.SEARCH_COMPLAINT);
    return {
        type: pageTypes.PAGE_GO_TO_START_PAGE
    };
}

export function changePageToCrateComplaintPreview() {
    return {
        type: pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PREVIEW_PAGE
    };
}


// WEBPACK FOOTER //
// ./src/actions/Page.js